// src/pages/Privacy.jsx
import React from 'react';
import './Privacy.css';
import Hero from '../components/Home/Hero';

export default function Privacy() {
  return (
    <>
      <Hero title="Privacyverklaring" />

      <section className="privacy-page py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm p-4">
                <h1 className="mb-4">Privacyverklaring</h1>

                <p>
                  Bij <strong>OnlineGrowthClub.nl</strong> hechten we veel waarde aan jouw privacy. In deze privacyverklaring leggen we uit welke persoonsgegevens we verzamelen, waarom we dat doen en hoe we hiermee omgaan.
                </p>

                <h2 className="mt-5">Welke gegevens verzamelen we?</h2>
                <p>
                  Wij verzamelen alleen gegevens die nodig zijn voor onze dienstverlening. Denk aan:
                </p>
                <ul>
                  <li>Naam en contactgegevens</li>
                  <li>Bedrijfsgegevens</li>
                  <li>Bezoekgegevens (via cookies)</li>
                  <li>Technische informatie zoals IP-adres en browsertype</li>
                </ul>

                <h2 className="mt-5">Waarom verzamelen we deze gegevens?</h2>
                <ul>
                  <li>Voor het opstellen van offertes en communicatie</li>
                  <li>Voor het verbeteren van onze website en marketing</li>
                  <li>Om onze dienstverlening te kunnen uitvoeren</li>
                </ul>

                <h2 className="mt-5">Delen van gegevens</h2>
                <p>
                  We delen jouw gegevens nooit met derden, tenzij dit nodig is voor de uitvoering van onze diensten (zoals hostingpartners) of wanneer dit wettelijk verplicht is.
                </p>

                <h2 className="mt-5">Jouw rechten</h2>
                <p>
                  Je hebt het recht om je gegevens in te zien, te corrigeren of te laten verwijderen. Neem hiervoor contact met ons op via <a href="mailto:info@onlinegrowthclub.nl">info@onlinegrowthclub.nl</a>.
                </p>

                <p className="mt-4 mb-0">
                  Deze privacyverklaring kan van tijd tot tijd worden aangepast. Controleer deze pagina regelmatig voor updates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
